import React from 'react';
import { translate } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChild, faMale } from '@fortawesome/pro-solid-svg-icons';
import { classes } from './styles/table';

class YoungCellComponent extends React.Component {

  render() {
    const { t, value } = this.props;
    return (
      <React.Fragment>
        <span className={classes.icon}>
          <FontAwesomeIcon icon={value ? faChild : faMale} />
        </span>
        {t(value ? 'table.ageYoung' : 'table.ageNotYoung')}
      </React.Fragment>
    )
  }

}

export default translate(['comm'])(YoungCellComponent);


// WEBPACK FOOTER //
// ./src/views/comm/young-cell.js